import React, {useState, useEffect} from "react";
import { connect, useSelector } from "react-redux";
import WizardStep from "../common/Wizard/WizardStep";
import { formatDateTimeToZone } from "../common/Helpers";


export function InvoiceWizard(props) {

    const invoice = useSelector(state => state.invoices.invoice);

    const [displaySendInvoice, setDisplaySendInvoice] = useState("future");
    const [displayReviews, setDisplayReviews] = useState(["future"]);
    const [displayPayment, setDisplayPayment] = useState("future");
    const [displayClose, setDisplayClose] = useState("future");

    useEffect(() => {
        // when invoice changes, update styling of each wizard step

        // ******* NEED TO ALSO TRIGGER WHEN STATUS CHANGES
        switch(invoice.stage) {
            case "DR": 
                setDisplaySendInvoice("ongoing");
                setDisplayReviews(invoice.approval_levels.map(approval_level => approval_level.is_rejected ? "rejected" : "future"));
                setDisplayPayment("future");
                setDisplayClose("future");
            break;
            case "REV": 
                setDisplaySendInvoice("success");
                setDisplayReviews(invoice.approval_levels.map((approval_level) => {
                    return approval_level.is_current_approval ? "ongoing" : 
                        (approval_level.is_rejected ? "rejected" : 
                            (approval_level.is_approved ? "success" : "future")
                        ) 
                }))
                setDisplayPayment("future");
                setDisplayClose("future");
            break;
            case "REJ": 
            case "RED": 
                setDisplaySendInvoice("ongoing");
                setDisplayReviews(invoice.approval_levels.map(approval_level => approval_level.is_rejected ? "rejected" : "future"));
                setDisplayPayment("future");
                setDisplayClose("future");
            break;
            case "CA": 
                setDisplaySendInvoice("schedule");
                setDisplayReviews(["schedule"]);
                setDisplayPayment("schedule");
                setDisplayClose("schedule");
            break;
            case "PR": 
                setDisplaySendInvoice("success");
                setDisplayReviews(invoice.approval_levels.map(approval_level => "success"));
                setDisplayPayment("ongoing");
                setDisplayClose(invoice.fk_user_stage_rejected_by ? "rejected" : "future");
            break;
            case "PU": 
                setDisplaySendInvoice("success");
                setDisplayReviews(invoice.approval_levels.map(approval_level => "success"));
                setDisplayPayment("success");
                setDisplayClose("ongoing");
            break;
            case "PC": 
                setDisplaySendInvoice("success");
                setDisplayReviews(invoice.approval_levels.map(approval_level => "success"));
                setDisplayPayment("success");
                setDisplayClose("success");
            break;
            // case "AI": 
            //     setDisplaySendInvoice();
            //     setDisplayReviews([]);
            //     setDisplayPayment();
            //     setDisplayClose();
            // break;
            // case "AC": 
            //     setDisplaySendInvoice();
            //     setDisplayReviews([]);
            //     setDisplayPayment();
            //     setDisplayClose();
            // break;
            default: console.log("error: missing invoice stage") ;
        }
    }, [invoice]);

    const vendorRepName = invoice.VCA.first_name ? invoice.VCA.first_name + " " + invoice.VCA.last_name : "Vendor Rep";
    const apName = invoice.AP.first_name ? invoice.AP.first_name + " " + invoice.AP.last_name : "Accounts Payable"
    const arName = invoice.AR.first_name ? invoice.AR.first_name + " " + invoice.AR.last_name : "Accounts Receivable" 
    const send_date = invoice.send_date ? "Sent " + formatDateTimeToZone(invoice.send_date) : "Day 0"
    const paid_date = invoice.payment_date ? "Paid " + formatDateTimeToZone(invoice.payment_date) : null
    const payment_confirmed_date = invoice.payment_confirmed_date ? "Closed " + formatDateTimeToZone(invoice.payment_confirmed_date) : null
    const payment_due_date = invoice.payment_due_date ? ("Due " + formatDateTimeToZone(invoice.payment_due_date)) : "No deadline";
    // const approvals_exist = invoice.approval_levels[0].parties[0] !== undefined
            
    return (
        <div className={`flex-row ${props.className}`} style={{marginLeft: "8px", marginRight: "-8px"}}>
            <WizardStep 
                step="Send Invoice" 
                party_name={vendorRepName} 
                date_done={send_date}
                display={displaySendInvoice}
                email={invoice.VCA.email} 
            />

            {invoice.approval_levels.map((approval_level, index) => {
                let is_only_reviewer = invoice.approval_levels.length === 1;
                let is_final_reviewer = index == invoice.approval_levels.length - 1;
                // solve for step
                let step = is_only_reviewer ? "Review" : (is_final_reviewer ? "Final Review" : "Initial Review");
                // solve for party_name
                let title = is_only_reviewer ? "Approver" : (is_final_reviewer ? "Final Approver" : "Initial Approver");
                let party_name = approval_level.parties.length > 0 ? (approval_level.parties[0].first_name + " " + approval_level.parties[0].last_name) : title;
                let email = approval_level.parties.length > 0 ? approval_level.parties[0].email : " ";
                let no_deadline = is_final_reviewer ? "No deadline" : "";
                let date_due = is_final_reviewer && invoice.review_due_date ? "Due " + formatDateTimeToZone(invoice.review_due_date) : no_deadline;
                let review_date = invoice.review_date ? "Approved " + formatDateTimeToZone(invoice.review_date) : null
                let final_review_date = invoice.final_review_date ? "Approved " + formatDateTimeToZone(invoice.final_review_date) : null;
                let date_done = index === 0 ? review_date : final_review_date
                let remaining = is_final_reviewer && invoice.review_days_left !== null ? invoice.review_days_left : null
                return (
                    <WizardStep 
                        key={index}
                        step={step}
                        party_name={party_name} 
                        date_due={date_due}
                        date_done={date_done}
                        display={displayReviews[index]}
                        email={email}
                        remaining={remaining} 
                    />
                )

            })}
            <WizardStep 
                step="Payment" 
                party_name={apName} 
                date_due={payment_due_date}
                date_done={paid_date}
                display={displayPayment}
                email={invoice.AP.email}
                remaining={invoice.payment_days_left}
            />
            <WizardStep 
                step="Close Invoice" 
                party_name={arName} 
                date_done={payment_confirmed_date}
                display={displayClose} 
                email={invoice.AR.email}
            />
        </div>
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(InvoiceWizard);

